
var CartSummary = function() {
	var self = this;

	this.$container = $('.cart-summary');
	this.$header    = this.$container.find('.header');
	this.$content   = this.$container.find('.content');
	this.$error     = this.$container.find('.error');
};

CartSummary.prototype.init = function() {
    var self = this;
    this.load();

   	this.$container.removeClass('hidden');
   	this.$header.click(function(e) {
   		e.stopPropagation();
   		e.preventDefault();

   		if (self.$content.is(':visible')) {
   			self.close();
   		} else {
   			self.open();
   		}
   	});

   	this.$content.click(function(e) {
   		e.stopPropagation();
   	});

   	$('.body-template, .cart-summary, .navbar, footer').click(function() {
   		self.close();
   	});

   	this.initAddButtons();
};

CartSummary.prototype.initAddButtons = function() {
    var self = this;

    $('.cart-add').off('click').on('click', function(e) {
         e.preventDefault();

         if ($(this).hasClass('cart-add-disabled')) {
             return true;
         }

         var $button = $(this);
         $button.addClass('disabled');

         var categoryId = $(this).data('category-id');
         var productId  = $(this).data('product-id');

         self.add(categoryId, productId, function() {
             setTimeout(function() {
                 $button.removeClass('disabled');
             }, 1000);
         });
     });
};

CartSummary.prototype.open = function() {
	if (this.$error.find('.alert').text() != '') {
		this.$error.slideDown('fast');
	}

	this.$container.addClass('open');
	this.$content.stop().slideDown('fast');
};

CartSummary.prototype.close = function() {
	this.$container.removeClass('open');
	this.$content.slideUp('fast');
	this.hideError();
};

CartSummary.prototype.load = function(callback) {
	var self = this;

	this.$container.addClass('loading');

	$.getJSON('/site/ajax/get_cart_summary.php', function(data) {
		self.$content.html(data.content);
		self.$header.find('.price').html(data.total);
		self.$container.removeClass('loading');

		if (typeof callback == 'function') {
			callback();
		}
	});
};

CartSummary.prototype.add = function(categoryId, productId, callback) {
	var self = this;

	$.getJSON('/site/ajax/add_cart.php', { category_id: categoryId, product_id: productId }, function(data) {
		$('.cart-summary').show();

		if (data != '') {
			self.addError(data.error);
		} else {
			self.hideError();
		}

		self.load(function() {
			self.highlight();
		});

		if (typeof callback == 'function') {
			callback();
		}
	});
};

CartSummary.prototype.hideError = function() {
	this.$error.slideUp('fast').find('.alert').text('');
};

CartSummary.prototype.addError = function(error) {
	this.$error.find('.alert').text(error);
};

CartSummary.prototype.highlight = function() {
	var self = this;

	this.open();

	//if (this.$container.hasClass('highlight')) {
	//	this.$container.removeClass('highlight');
	//	clearTimeout(this.highlightTimeout);
	//}

	//this.$container.addClass('highlight');
	//this.highlightTimeout = setTimeout(function() {
	//	self.$container.removeClass('highlight');
	//}, 1000);
};
